import { render, staticRenderFns } from "./SideBarNotes.vue?vue&type=template&id=6521b204"
import script from "./SideBarNotes.vue?vue&type=script&lang=js"
export * from "./SideBarNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports